import { createClient } from '@supabase/supabase-js';

// Production release marker: Stock Transfer integrity and legacy receiving (#123).
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);

function makeRealtimeSafe(client) {
  if (!client || client.__helloHbRealtimeSafe) return client;

  const originalChannel = client.channel.bind(client);
  client.channel = (...args) => {
    const channel = originalChannel(...args);
    if (!channel || channel.__helloHbSafeOn) return channel;

    const originalOn = channel.on.bind(channel);
    channel.on = (...onArgs) => {
      try {
        return originalOn(...onArgs);
      } catch (error) {
        const message = String(error?.message || error || '');
        // A late realtime callback must never blank the ERP/POS screen.
        // The next normal data refresh still keeps business data usable.
        if (message.includes('callbacks') && message.includes('after `subscribe()`')) {
          console.warn('HELLOHB ignored an invalid late realtime callback:', message);
          return channel;
        }
        throw error;
      }
    };
    Object.defineProperty(channel, '__helloHbSafeOn', { value: true });
    return channel;
  };

  Object.defineProperty(client, '__helloHbRealtimeSafe', { value: true });
  return client;
}

export const supabase = isSupabaseConfigured
  ? makeRealtimeSafe(createClient(supabaseUrl, supabaseKey))
  : null;
